import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../lib/api';

/**
 * Compact credit balance indicator for the navigation header.
 * Shows current balance and links to the credits page.
 * Highlights in yellow when balance is low.
 */
export function CreditBalanceIndicator() {
  const [balance, setBalance] = useState<number | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .getCreditBalance()
      .then((data) => setBalance(data.balance))
      .catch(() => setBalance(null));

    // Refresh every 60 seconds
    const interval = setInterval(() => {
      api
        .getCreditBalance()
        .then((data) => setBalance(data.balance))
        .catch(() => {});
    }, 60_000);

    return () => clearInterval(interval);
  }, []);

  if (balance === null) return null;

  const isLow = balance < 50;
  const displayAmount = Math.round(balance).toLocaleString();

  return (
    <button
      onClick={() => navigate('/credits')}
      title="Credit balance - click to manage"
      className={`flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full transition-colors ${
        isLow
          ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300 hover:bg-yellow-200 dark:hover:bg-yellow-900/50'
          : 'bg-muted text-muted-foreground hover:bg-accent'
      }`}
    >
      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        <circle cx="12" cy="12" r="7" stroke="currentColor" strokeWidth="1" opacity="0.4" />
        <text
          x="12"
          y="16.5"
          textAnchor="middle"
          fill="currentColor"
          fontSize="12"
          fontWeight="bold"
          fontFamily="sans-serif"
        >
          F
        </text>
      </svg>
      {displayAmount}
    </button>
  );
}
